import React from 'react';
import type { FeedbackItem, FeedbackVoteValue } from '../../lib/feedback';
import FeedbackCard from './FeedbackCard';

interface FeedbackListProps {
  items: FeedbackItem[];
  votesById: Record<string, FeedbackVoteValue | 0>;
  onVote: (feedbackId: string, desired: FeedbackVoteValue) => void;
  votingId?: string | null;
}

const FeedbackList: React.FC<FeedbackListProps> = ({
  items,
  votesById,
  onVote,
  votingId,
}) => {
  if (!items.length) {
    return (
      <div className="rounded-lg border border-dashed border-slate-200 bg-slate-50 p-6 text-center text-sm text-slate-500">
        No feedback yet — be the first.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {items.map((item) => (
        <FeedbackCard
          key={item.id}
          item={item}
          userVote={votesById[item.id] || 0}
          onVote={onVote}
          isVoting={votingId === item.id}
        />
      ))}
    </div>
  );
};

export default FeedbackList;
